// extracted by mini-css-extract-plugin
export default {"root":"YAN2l","rootDesktop":"z2c17","rootEmptyLoading":"pR_b9","spinner":"QqpL0"};